<template>
  <div class="col-12 ">

    <b-table
      v-if="examFisicos.examenes.length > 0"
      :items="examFisicos.examenes" 
      :fields="tableFields"
      class="text-center px-1 mt-1"
      responsive small
    >
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>
    </b-table>

    <div 
      v-if="examFisicos.examenes.length > 0" 
      class="mt-2 px-1"
    >
      Observaciones: {{ examFisicos.observaciones ? examFisicos.observaciones : 'No registra observaciones' }}
    </div>
  </div>
</template>

<script>
import { anamnesisService } from '@/views/atencionMedica/services';

export default {

  name: "ExamFisicoTable",

  props: {
    tokenAtencion: {
      type: String,
      required: true
    },

    value: {
      type: Boolean,
      default: false
    }
  },

  created() {
    this.loadData();
  },

  data(){
    return{

      examFisicos:{
        examenes:[],
        observaciones:''
      },

      tableFields: [
        { 
          key: "index", 
          label: "N°", 
          thClass: "text-center", 
          tdClass: "text-center" 
        },
        { 
          key: "examenfisico.descripcion", 
          label: "Examen", 
          thClass: "text-left",
          tdClass: "text-left" 
        },
        { 
          key: "descripcionGeneral",       
          label: "descripcion",       
          thClass: "text-left",
          tdClass: "text-left"

        }
      ]
    }
  },

  methods: {
    async loadData(){
      if( !this.tokenAtencion ) return;
      this.examFisicos = await anamnesisService.getExamFisicosByAtencion(this.tokenAtencion);
    },

    emitHasData() {
      const hasData = this.examFisicos.examenes.length > 0 || !!this.examFisicos.observaciones;
      this.$emit('input', hasData);
    }
  },

  watch: {
    tokenAtencion: {
      deep: true,
      handler: 'loadData'
    },

    examFisicos: {
      deep: true,
      handler() {
        this.emitHasData();
      }
    }
  }
}
</script>